import React from 'react';
import { Box, Grid } from '@mui/material';
import SectionCard from 'ui-components/SectionCard';
import Shimmer from 'ui-components/Shimmer';

// Placeholder for the startup detail shell and its default Profile tab
// (StartupInformation.js): tab strip, logo + name + Email, Company Highlights,
// Problem Overview, and the Founders / Pitch Deck column.
const TABS = 7;
const HIGHLIGHTS = 6;

const CardTitle = ({ width }) => (
  <Shimmer width={width} height={18} radius={4} sx={{ mb: 2 }} />
);

const StartupDetailSkeleton = () => (
  <Box sx={{ width: '100%', px: { xs: '1rem', sm: '2rem' }, pb: '2rem' }}>
    {/* Tab strip */}
    <Box sx={{ display: 'flex', gap: 3, py: 2, overflow: 'hidden' }}>
      {Array.from({ length: TABS }).map((_, i) => (
        <Shimmer key={i} width={i === 0 ? 56 : 84} height={14} radius={4} />
      ))}
    </Box>

    <Grid container columnSpacing={2} rowSpacing={3}>
      {/* ---- Left column ---- */}
      <Grid item xs={12} lg={8}>
        {/* Logo + name + Email button */}
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2.5, mb: 3 }}>
          <Shimmer width={134} height={134} radius={12} />
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
            <Shimmer width={180} height={28} radius={6} />
            <Shimmer width={112} height={44} radius={10} />
          </Box>
        </Box>

        {/* Company Highlights: six label + value pairs, three per row */}
        <SectionCard>
          <CardTitle width={190} />
          <Grid container rowSpacing={3} columnSpacing={2}>
            {Array.from({ length: HIGHLIGHTS }).map((_, i) => (
              <Grid item xs={12} sm={6} lg={4} key={i}>
                <Shimmer width={130} height={11} radius={4} sx={{ mb: 1 }} />
                <Shimmer width={i % 3 === 1 ? '85%' : '55%'} height={13} radius={4} />
              </Grid>
            ))}
          </Grid>
        </SectionCard>

        {/* Problem Overview */}
        <SectionCard sx={{ marginTop: '1.25rem' }}>
          <CardTitle width={150} />
          <Shimmer width="100%" height={110} radius={8} />
        </SectionCard>
      </Grid>

      {/* ---- Right column: Founders + Pitch Deck ---- */}
      <Grid item xs={12} lg={4}>
        <SectionCard sx={{ padding: '1rem', marginTop: 0, width: '100%' }}>
          <CardTitle width={110} />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, border: '1px solid #EAECF0', borderRadius: '12px', p: 2 }}>
            <Shimmer width={44} height={44} radius={22} />
            <Shimmer width="55%" height={15} radius={4} />
          </Box>
        </SectionCard>

        <SectionCard sx={{ padding: '1rem', marginTop: '1.25rem', width: '100%' }}>
          <CardTitle width={110} />
          <Shimmer width="100%" height={190} radius={8} />
        </SectionCard>
      </Grid>
    </Grid>
  </Box>
);

export default StartupDetailSkeleton;
